/* Meteor menu, touch screens (#167).
   Meteor turns a tap on a top-level link into an open/close toggle and never
   follows the link. First tap opens the dropdown, a tap on the open item now
   goes to its collection. Mouse users are untouched. */
(function () {
  var LINK = 'a.Meteor-Navigation__Link__desktop[aria-haspopup="true"]';
  var touched = null;
  var wasOpen = false;

  function isOpen(li) {
    return li.getAttribute('data-active-with-content') === 'true';
  }

  document.addEventListener('touchstart', function (e) {
    var link = e.target.closest && e.target.closest(LINK);
    touched = link;
    wasOpen = !!link && isOpen(link.parentElement);
  }, { capture: true, passive: true });

  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest(LINK);
    if (!link || link !== touched) return;
    touched = null;

    // Keep Meteor's own click handler out of it.
    e.stopPropagation();
    if (wasOpen) return;

    e.preventDefault();
    var li = link.parentElement;
    if (!isOpen(li)) li.dispatchEvent(new MouseEvent('mouseover', { bubbles: true }));
  }, true);
})();

/* Meteor menu on tablets (#167): Gary asked for the mobile "All ..." link at
   the top of every dropdown, centred and set apart from the sub-collections. */
(function () {
  if (!window.matchMedia('(hover: none)').matches) return;

  function parentLink(nav) {
    var level = nav.getAttribute('data-parent-level');
    if (level === '0') {
      return document.querySelector('li[data-active-with-content="true"] > a.Meteor-Navigation__Link__desktop');
    }
    var tier = document.querySelector('.meteor-menu .m-tier-' + level);
    return tier && tier.querySelector('.m-nav[data-active="true"] a.m-link[data-active="true"]');
  }

  function addAllLinks() {
    document.querySelectorAll('.meteor-menu .m-nav[data-active="true"]').forEach(function (nav) {
      var parent = parentLink(nav);
      if (!parent) return;
      var href = parent.getAttribute('href');
      var first = nav.firstElementChild;
      if (first && first.classList.contains('ss-all-link')) {
        if (first.getAttribute('href') === href) return;
        first.remove();
      }
      var a = document.createElement('a');
      a.className = 'm-link ss-all-link';
      a.setAttribute('role', 'menuitem');
      a.href = href;
      a.textContent = 'All ' + parent.textContent.trim();
      nav.insertBefore(a, nav.firstChild);
    });
  }

  new MutationObserver(addAllLinks).observe(document.body, {
    subtree: true, childList: true, attributes: true, attributeFilter: ['data-active']
  });
})();
